'use client'

import React, { useState } from "react";
import styles from "./StatsSectionHomeNew.module.scss";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import "swiper/css";

interface StatItem {
  number: string;
  label: string;
}

const statsData: StatItem[] = [
  { number: "30+", label: "Years Of Academic Excellence" },
  { number: "80+", label: "Programs & Specializations" },
  { number: "250,000+", label: "Global Learner Network" },
  { number: "450+", label: "Hiring partners" },
];
const statsDataHaridwar: StatItem[] = [
  { number: "250,000+", label: "Global Learner Network" },
  { number: "30+", label: "Years Of Academic Excellence" },
  { number: "80+", label: "Programs & Specializations" },
  { number: "450+", label: "Hiring partners" },
];

const StatsSection= ({isHaridwar=false}) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const activeStats=isHaridwar? statsDataHaridwar:statsData
  return (
    <section className={styles.statsContainer}>
      <div className={styles.statsWrapper}>
        {/* Desktop Layout */}
        <div className={styles.desktopStats}>
          {activeStats.map((stat, index) => (
            <React.Fragment key={index}>
              <div className={styles.statBox}>
                <p className={styles.number}>{stat.number}</p>
                <p className={styles.label}>{stat.label}</p>
              </div>

              {index < activeStats.length - 1 && (
                <div className={styles.divider} />
              )}
            </React.Fragment>
          ))}
        </div>
        {/* Mobile Swiper */}
        <div className={styles.mobileStats}>
          <Swiper
            modules={[Autoplay]}
            slidesPerView={2}
            spaceBetween={0}
            loop={false}
            speed={400}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)}
          >
            {activeStats.map((stat, index) => {
              const isRightCard = index === activeIndex + 1;

              return (
                <SwiperSlide key={index}>
                  <div
                    className={`${styles.mobileSlideContainer} ${
                      isRightCard ? styles.rightCard : ""
                    }`}
                  >
                    <div className={styles.mobileStatBox}>
                      <p className={styles.number}>{stat.number}</p>
                      <p className={styles.label}>{stat.label}</p>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default StatsSection;